import httpApi from './http.api'

export const composeUrl = (...parts) => {
  const urlSeparator = '/'
  parts = parts.map(p => p ? p.toString() : '')
  const res = parts.filter(p => p.length > 0).map(p => {
    if (p.charAt(0) === urlSeparator) p = p.substr(1)
    if (p.charAt(p.length - 1) === urlSeparator) p = p.substr(0, p.length - 1)
    return p
  }).join(urlSeparator)

  return urlSeparator + res + urlSeparator
}

export default class BaseApi {
  constructor(url) {
    this.url = url
    this.httpApi = null
    this.initHttpApi()
  }

  initHttpApi() {
    if (!this.httpApi) {
      import('./http.api').then(module => {
        this.httpApi = module.default
      }).catch(error => console.error('Error loading httpApi:', error))
    }
  }

  encodeQueryData(data) {
    const ret = []
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
    return ret.join('&')
  }

  getUrlWithParams(url, parameters) {
    var querystring = this.encodeQueryData(parameters)
    if (!url.endsWith('/')) {
      url += '/'
    }
    return `${url}?${querystring}`
  }

  getAbsoluteUrl(url = this.url) {
    return `${this.getBaseApi()}${url}`
  }

  getBaseApi() {
    return `${window.config.BASE_API}`
  }

  getBaseMediaUrl() {
    return `${window.config.BASE_MEDIA}`
  }

  download(url, fileName, params = null, isUrlSpecified = false, config = {}) {
    const downloadUrl = isUrlSpecified ? url : composeUrl(this.url, url)
    params = params || {}
    return httpApi({
      url: downloadUrl,
      method: 'get',
      params: params,
      responseType: 'blob',
      ...config
    }).then(res => {
      if (res.status === 202) {
        return
      }

      let backendFilename = null
      const disposition = res.headers.get('content-disposition')
      if (disposition && disposition.includes('filename=')) { backendFilename = disposition.split('filename=')[1].replace(/"/g, '') }
      fileName = fileName || backendFilename || 'download'

      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    })
  }

  downloadBlob(url, params, isUrlSpecified = false, config = {}, fileName = null) {
    const downloadUrl = isUrlSpecified ? url : composeUrl(this.url, url)
    params = params || {}
    return httpApi({
      url: downloadUrl,
      method: 'get',
      params: params,
      responseType: 'blob',
      ...config
    }).then(res => {
      if (fileName) {
        let resolvedName = fileName
        const disposition = res.headers.get('content-disposition')
        if (!resolvedName && disposition && disposition.includes('filename=')) {
          resolvedName = disposition.split('filename=')[1].replace(/"/g, '')
        }
        res.fileName = resolvedName || 'download'
      }
      return res
    })
  }

  get(url, params, config) {
    return httpApi({
      url: composeUrl(this.url, url),
      method: 'get',
      params: params,
      ...config
    })
  }

  post(url, data, config) {
    return httpApi({
      url: composeUrl(this.url, url),
      method: 'post',
      data: data,
      ...config
    })
  }

  put(url, data, config) {
    return httpApi({
      url: composeUrl(this.url, url),
      method: 'put',
      data: data,
      ...config
    })
  }

  patch(url, data, config) {
    return httpApi({
      url: composeUrl(this.url, url),
      method: 'patch',
      data: data,
      ...config
    })
  }

  delete(url, config) {
    return httpApi({
      url: composeUrl(this.url, url),
      method: 'delete',
      ...config
    })
  }

  getLastUpdate(url) {
    return this.get(url + 'last-update')
  }
}
